<app-loader *ngIf="isLoading()"></app-loader>
<div class="container container-profile container-profile-job" [ngClass]="{'d-none': isLoading()}">

  <!-- cover -->
  <div class="container-fluid container-cover-wrapper">
    <div class="container-cover">
      <div class="ovaalcontainer2">
        <div class="row">
          <div class="cover-photo" [ngStyle]="{'background-image': 'url(' + ( entity.trademark &&  entity.trademark.coverPhotoUri ? entity.trademark.coverPhotoUri : entity.company.coverPhotoUri) + ')'}">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <div class="container-fluid container-content">

    <div class="content-wrapper">

      <div class="row">

        <div class="sidebar sidebar-left col-12 col-sm-3">

          <div class="content">

            <!-- company profile data -->
            <div class="card mb-3">

              <div class="card-body">

                <div class="company-logo">
                  <div class="circle">
                    <a [routerLink]="'/companies/' + entity.company.id">
                    <img class="image logo-image" [src]="(entity.trademark && entity.trademark.avatarUri ? entity.trademark.avatarUri : entity.company.avatarUri)" />
                    </a>
                  </div>
                </div>

                <div class="company-info">

                  <a [routerLink]="'/companies/' + entity.company.id">
                    <h2 class="text-center">{{(entity.trademark && entity.trademark.name ? entity.trademark.name : entity.company.name)}}</h2>
                  </a>

                  <div *ngIf="entity.areaOfInterests.length > 0" class="interests text-center mb-3">
                    <fa-icon [icon]="faBinoculars"></fa-icon>
                    <span *ngFor="let interest of entity.areaOfInterests; let key = index;">
                      {{key == (entity.areaOfInterests.length -1) ? interest.name + '' : interest.name + ', '}}
                    </span>
                  </div>

                  <div *ngIf="entity.company.visitAddress.city" class="location text-center mb-3">
                    <fa-icon [icon]="faMapMarkerAlt"></fa-icon> {{entity.company.visitAddress.city}}
                  </div>


                </div>

              </div>

            </div>

            <!-- network -->
            <div class="card mb-3" *ngIf="userService.currentUserHasRole(RoleTypes.Student)">

              <div class="card-body">
                <button [disabled]="isProcessing" *ngIf="!entity.company.isCurrentUserFavorite" (click)="addCompanyAsFavorite()" class="btn btn-outline-primary btn-block">
                  <fa-icon [icon]="faLink"></fa-icon> {{'Connect' | translate}}
                </button>
                <button [disabled]="isProcessing" *ngIf="entity.company.isCurrentUserFavorite" (click)="deleteCompanyAsFavorite()" class="btn btn-outline-primary btn-block">
                  <fa-icon [icon]="faUnlink"></fa-icon> {{'Disconnect' | translate}}
                </button>
              </div>

            </div>

            <!-- share social -->
            <div class="card social-media mt-3 d-flex align-items-center justify-content-center">
              <div class="card-body">

                <h5 class="card-title">{{'Share on social media' | translate}}</h5>

                <ul class="social-media-links d-flex justify-content-center">
                  <li class="social-media-item">
                    <a  class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="getSocialShareLink('facebook')">
                      <fa-icon [icon]="faFacebookF"></fa-icon>
                    </a>
                  </li>
                  <li class="social-media-item">
                    <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="getSocialShareLink('twitter')">
                      <fa-icon [icon]="faXTwitter"></fa-icon>
                    </a>
                  </li>
                  <li class="social-media-item">
                    <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="getSocialShareLink('linkedin')">
                      <fa-icon [icon]="faLinkedinIn"></fa-icon>
                    </a>
                  </li>
                </ul>

              </div>

            </div>

          </div>

        </div>

        <!-- main content -->
        <div class="col-12 col-sm-9 main-content">

          <div class="btn-toolbar justify-content-end" *ngIf="userService.currentUserHasRole(RoleTypes.Student)">
            <button (click)="applyForJobPosting(entity.id)" class="btn btn-primary">
              {{'Apply' | translate}}
            </button>

            <a class="btn btn-secondary ml-2" *ngIf="entity.documents.length > 0 && userService.currentUserHasRole(RoleTypes.Student)" [href]="entity.documents[0]['uri']" target="_blank">
              <fa-icon [icon]="faDownload"></fa-icon> {{'Attachment' | translate}}
            </a>

            <button *ngIf="!entity.isCurrentUserFavorite" (click)="addJobPostingToFavorite(entity.id)" class="btn btn-outline-danger ml-2">
              <fa-icon [icon]="farHeart"></fa-icon> {{'My jobs' | translate}}
            </button>

            <button *ngIf="entity.isCurrentUserFavorite" (click)="deleteJobPostingToFavorite(entity.id)" class="btn btn-outline-danger ml-2">
              <fa-icon [icon]="faHeart"></fa-icon> {{'My jobs' | translate}}
            </button>

          </div>

          <h3 class="job-title">{{entity.title}}</h3>

          <!-- meta data job -->
          <div class="card mt-3 entity-meta-data">
            <div class="card-body">

              <!-- top meta description of job posting -->
              <div class="row mb-4">

                <!-- immediately available -->
                <div *ngIf="entity.immediatelyAvailable == true" class="col-12 immediately-available">
                  {{'Immediately' | translate}}
                </div>

                <!-- area of interests -->
                <div class="col-12" *ngIf="entity.areaOfInterests.length > 0">
                  {{'Field of interest' | translate}}:
                  <span *ngFor="let interest of entity.areaOfInterests;let key = index">
                    {{interest.name | translate}}{{(key == entity.areaOfInterests.length - 1 ? '' : ', ')}}
                  </span>
                </div>

                <!-- startdate -->
                <div *ngIf="entity.startDate" class="col-12 deadline">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{'Start date' | translate}}: {{entity.startDate | date:'dd-MM-YYYY'}}
                </div>

                <!-- deadline -->
                <div *ngIf="entity.deadline" class="col-12 deadline">
                  <fa-icon [icon]="faCalendarTimes"></fa-icon>
                  {{'Deadline' | translate}}: {{entity.deadline | date:'dd-MM-YYYY'}}
                </div>

              </div>

              <div class="row">

                <!-- type -->
                <div class="col-6 col-sm-4" *ngIf="entity.type">
                  <fa-icon [icon]="faInfoCircle"></fa-icon>
                  <div>
                    {{'Type' | translate}}: {{entity.type | translate}}
                  </div>
                </div>

                <!-- education levels -->
                <div class="col-6 col-sm-4" *ngIf="entity.educationLevels.length > 0">
                  <fa-icon [icon]="faGraduationCap"></fa-icon>
                  <div>
                     <span *ngFor="let educationLevel of entity.educationLevels;let key = index">
                      {{educationLevel.name | translate}}{{(key == entity.educationLevels.length - 1 ? '' : ', ')}}
                      </span>
                  </div>

                </div>

                <!-- location -->
                <div class="col-6 col-sm-4" *ngIf="entity.location">
                  <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                  <div>
                    {{'Location' | translate}}: {{entity.location | translate}}
                  </div>
                </div>

                <!-- external reference URI -->
                <div class="col-6 col-sm-4" *ngIf="entity.externalReferenceUri && userService.currentUserHasRole(RoleTypes.Student)">
                  <fa-icon [icon]="faFileContract"></fa-icon>
                  <div>
                    <a class="btn btn-outline-secondary" [href]="entity.externalReferenceUri" target="_blank">
                      <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
                      {{'Apply directly' | translate}}
                    </a>
                  </div>

                </div>

              </div>

            </div>
          </div>

          <!-- extended job information -->
          <div class="card mt-3 entity-job-information">
            <div class="card-body">

              <div *ngIf="entity.description" class="entity-description">
                <h5 class="card-title">{{'Job description' | translate}}</h5>
                <span class="entity-description-text ck-content" [innerHTML]="entity.description"></span>
              </div>

              <div *ngIf="entity.requirements" class="entity-job-requirements mt-3">
                <h5 class="card-title">{{'Job requirements' | translate}}</h5>
                <span class="entity-job-requirements-text ck-content" [innerHTML]="entity.requirements"></span>
              </div>

              <div *ngIf="entity.termsOfEmployment" class="entity-employment-conditions mt-3">
                <h5 class="card-title">{{'Employment conditions' | translate}}</h5>
                <span class="entity-employment-conditions-text ck-content" [innerHTML]="entity.termsOfEmployment"></span>
              </div>

              <div *ngIf="entity.additionalInfo" class="entity-additional-information mt-3">
                <h5 class="card-title">{{'Additional information' | translate}}</h5>
                <span class="entity-additional-information-text ck-content" [innerHTML]="entity.additionalInfo"></span>
              </div>

            </div>
          </div>

          <!-- contact information -->
          <div class="card mt-3 contact-information" *ngIf="entity.contactPerson && userService.currentUserHasRole(RoleTypes.Student)">

           <div class="card-body">
             <h5 class="card-title">{{'Contact' | translate}}</h5>

             <div *ngIf="entity.contactPerson.firstName">
               {{'Contact person' | translate}}: {{entity.contactPerson.firstName + ' ' + entity.contactPerson.lastName}}
             </div>

             <div *ngIf="entity.contactPerson.emailAddress">
               {{'Email' | translate}}: {{entity.contactPerson.emailAddress}}
             </div>
           </div>

          </div>

          <!-- related jobs -->
          <div class="card" *ngIf="entity.related_jobs && entity.related_jobs.length>0">
            <h5>{{'Maybe these job openings are also interesting for you' | translate}}</h5>

            <table class="table table-striped">
              <thead>
                <tr>
                  <td>
                    {{'Company' | translate}}
                  </td>
                  <td>
                    {{'Job title' | translate}}
                  </td>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let job of entity.related_jobs" class="">
                <td class="related-job">
                  {{job['company_name']}}
                </td>
                <td>
                  {{job['title']}}
                </td>
              </tr>
              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
